<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="2">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportProfitChartInfo()" icon="el-icon-refresh">
              导出</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportProfitChartDetailInfo()" icon="el-icon-refresh">
              导出明细</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
    :cell-style="{'text-align':'center'}">
      <el-table-column prop="orderId" label="序号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="profitDateTime" label="日期" :formatter="dateFormater" />
      <el-table-column prop="returnMoney" label="返款手续费">
        <template slot-scope="scope">
          <span>{{scope.row.returnMoney != null?scope.row.returnMoney:0.0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="afterReview" label="后置评价">
        <template slot-scope="scope">
          <span>{{scope.row.afterReview != null?scope.row.afterReview:0.0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profitMoney" label="利润">
        <template slot-scope="scope">
          <span>{{scope.row.profitMoney != null?scope.row.profitMoney:0.0}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryOrderProfit} from "../../api/b2cbusiness/b2c_admin";
import {formate_param_date} from "../../lib/utils";
import qs from "qs";
export default {
  name: "OrderProfitChart",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
      },
      tableHeight:650,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.body.clientHeight - 320;
    //this.getData();
  },
  methods: {
    exportProfitChartDetailInfo(){
      window.open("https://api.weiquanai.com/b2cadmindatacharts/exportorderprofitdetail?"+qs.stringify({
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null
      }), "_blank");
    },
    exportProfitChartInfo(){
      window.open("https://api.weiquanai.com/b2cadmindatacharts/exportorderprofit?"+qs.stringify({
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
    },
    dateFormater(row, column){
      return formate_param_date("YYYY-mm-dd", row[column.property]);
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
    setData(data){
      console.log(data)
      if (data.success){
        this.tableData = data.data.records;
        this.pagination.pageNum = data.data.current;
        this.pagination.pageSize = data.data.size;
        this.pagination.total = data.data.total;
      }
    },
    getData(){
      queryOrderProfit(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    }
  },
  beforeRouteEnter(to, from, next){
    queryOrderProfit({},{pageNum: 1, pageSize: 20}).then(res=>{
      next(vm => vm.setData(res));
    });
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
